import BasalCard from "@/components/BasalCard";
import { ContentProps } from "@/components/ContentPromotions/types/ContentProps.interface";
import removeHTMLTags from "@/view/utils/removeHTMLTags";

const MonolithContentCard = (props: ContentProps) => {
  const { content_id, date_published, description, title, url, members } =
    props;

  const MAX_IMAGES_COUNT = 4;

  const images =
    members?.slice(0, MAX_IMAGES_COUNT).map(({ image }) => {
      return {
        alt_text: image?.alt_text ?? "",
        formatted_url: image?.formatted_url ?? "",
        url: image?.url ?? "",
      };
    }) ?? [];

  return (
    <BasalCard
      contentId={content_id ?? ""}
      displayDate={date_published ?? ""}
      subHeader={removeHTMLTags(description)}
      title={title}
      href={`/${url}`}
      images={images}
    />
  );
};

export default MonolithContentCard;
